import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { User } from '@/types/models/user';
import { showSide } from '@/store/slices/sideSlice';
import { useAppDispatch } from '@/hooks/redux';
import NavbarUserProfile from '@/components/Layouts/Default/Partials/Navbar/components/mobile/NavbarUserProfile';
import AuthenticatedMenu from '@/components/Layouts/Default/Partials/Navbar/components/mobile/AuthenticatedMenu';
import UnauthenticatedMenu from '@/components/Layouts/Default/Partials/Navbar/components/mobile/UnauthenticatedMenu';
import { sideKey } from '@/components/Common/Sides/types';

const NavbarMobileMenu = ({
  user,
  logout,
  isMenuOpen,
  setIsMenuOpen,
}: {
  user: User | null;
  logout: () => void;
  isMenuOpen: boolean;
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const dispatch = useAppDispatch();

  const openSide = (sideKey: string) => {
    dispatch(showSide({ sideKey: sideKey as sideKey }));
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="absolute top-0 left-0 right-0 bg-white first-letter: flex flex-col items-center gap-10 h-screen w-screen pt-16 z-50">
      {user ? (
        <>
          <NavbarUserProfile user={user} />
          <AuthenticatedMenu logout={logout} />
        </>
      ) : (
        <UnauthenticatedMenu openSide={openSide} />
      )}
      <FontAwesomeIcon
        className="absolute top-5 right-5 cursor-pointer text-[26px] text-gray-medium"
        icon="xmark"
        onClick={() => setIsMenuOpen(false)}
      />
    </div>
  );
};

export default NavbarMobileMenu;
